'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeLine3dIcon = function TraceTypeLine3dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement(
            'g',
            { fill: 'none' },
            _react2.default.createElement('path', { d: 'M0 0h46v46H0z' }),
            _react2.default.createElement('path', { stroke: '#25fdfc', d: 'M23.511 23.571l.005-15.302L37 14.295v15.75l-13.489-6.474z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
            _react2.default.createElement('path', { stroke: '#25fdfc', d: 'M23.511 23.571L9.516 30.045l13.929 6.319L37 30.045l-13.489-6.474z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
            _react2.default.createElement('path', { stroke: '#25fdfc', d: 'M9.516 30.045v-15.75l13.999-6.026-.004 15.302-13.995 6.474z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
            _react2.default.createElement('path', { d: 'M31.536 15.247a6.357 6.357 0 0 1-4.188 6.763c-5.017 2.166-11.255.028-11.255-3.14s5.11-3.87 7.48-3.87 7.48 1.908 7.48 5.684c0 3.654-3.797 5.485-8.216 5.566s-6.744-2.266-6.744-4.104 2.786-3.986 7.458-3.986 7.492 3.526 7.492 5.934a5.722 5.722 0 0 1-2.82 5.074', stroke: '#1d9bfb', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' })
        )
    );
};

exports.default = TraceTypeLine3dIcon;